// extracted by mini-css-extract-plugin
module.exports = {"staked__container":"Staked_staked__container__wRtL3"};